// extracted by mini-css-extract-plugin
export default {"wrap":"wrap_cZAMD","noBorder":"noBorder_QYhmX"};